export default {
	ProceduceTitle: 'Hướng dẫn xử lý hóa đơn chỉ với 3 bước',
	ProceduceTitleV2: 'HƯỚNG DẪN XỬ LÝ<br>HÓA ĐƠN CHỈ VỚI 3 BƯỚC',
	SendInvoiceTo: 'Gửi hóa đơn đến ',
	DescriptionAutomatic:
		'Phần mềm sẽ tự động đọc email, kiểm tra tra cứu và xử lý hóa đơn điện tử.<br>Nếu đã có file hóa đơn điện tử tải lên ',
	UploadHere: 'tại đây. (zip, xml)',
	InvoiceChecked: 'Kiểm tra hóa đơn',
	SystemAutoChecked:
		'Phần mềm tự động kiểm tra các thông tin trên hóa đơn để đảm bảo tính hợp pháp hợp lệ.',
	ViewInvoices: 'Xem danh sách hóa đơn',
	AccountingSynchronized: 'Đồng bộ vào phần mềm kế toán MISA',
	DescriptionSynchronized:
		'Đồng bộ với để tự động ghi nhận, hạch toán hóa đơn<br> MISA SME.NET 2021... ',
	ViewGuide: 'Xem hướng dẫn',
	ExportHere: 'Trường hợp không dùng kế toán, xuất excel danh sách hóa đơn',
	SendEmailTo:
		'Bạn gửi hoặc chuyển tiếp (forward) email hóa đơn điện tử đến ',
	ProceduceStep2:
		'MISA meInvoice tự động xử lý các hóa đơn điện tử được gửi đến email nhận hóa đơn.',
	ProceduceStep3:
		'Xuất khẩu hoặc đồng bộ với phần mềm kế toán để ghi nhận, hạch toán hóa đơn.',
	StartNow: 'Bắt đầu sử dụng'
};
